import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import EmailIcon from '@mui/icons-material/Email';
import { Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';

import { CenterCellContainer } from './CenterCellContainer';
import { formatDateTime } from 'FRONTEND/components/ConsultationTable/ConsultationColumns';
import i18n from 'FRONTEND/utils/i18n';

export const CellIcon = ({ value, iconName, userTimezone }: { value: string, iconName: 'notes' | 'reminder' | 'unread', userTimezone: string }) => {
  if (!value) {
    return '';
  }
  const isDate = dayjs(value).isValid();
  const isExpired = isDate && dayjs(value).isBefore(dayjs());
  const isDateAndExpired = isDate && isExpired;

  const iconMap = {
    notes: <ChatBubbleOutlineIcon fontSize='small' />,
    reminder: <AccessTimeIcon fontSize='small' color={isDateAndExpired ? 'error' : 'inherit'} />,
    unread: <EmailIcon fontSize='small' color='error' />,
  };
  let tooltipContent = '';
  if (isDate) {
    tooltipContent = `${i18n._('Reminder')}: ${formatDateTime(value, userTimezone)} ${isExpired ? `(${i18n._('Expired')})` : ''}`;
  } else {
    tooltipContent = value;
  }

  return (
    <CenterCellContainer>
      <Tooltip
        title={tooltipContent}
        slotProps={{
          tooltip: {
            sx: {
              maxWidth: 600,
              maxHeight: 300,
              fontSize: '1rem',
              overflowY: 'auto',
              lineHeight: 1.5,
              p: 1.5,
              whiteSpace: 'pre-line',
            },
          },
        }}
      >
        {iconMap[iconName]}
      </Tooltip>
    </CenterCellContainer>
  );
};
